
import { apiClient } from '@/config/api';
import { ApiResponse } from '@/types/status';
import {
    CreateUserDto,
    UpdateUserDto,
    ChangePasswordDto,
    UpdatePasswordDto,
    GetPaginationUsersDto,
    UserListResponse,
    UserResponse
} from '@/types/user';

// Thêm endpoints cho User API
const USER_ENDPOINTS = {
    USERS: '/users',
    GET_ALL: '/users/get-all',
    GET_ALL_BY_ADMIN: '/users/get-all-by-admin',
    CHANGE_PASSWORD: '/users/change-password',
    UPDATE_PASSWORD: '/users/up-password',
    UPDATE_ME: '/users/me'
};

export const userService = {
    // Lấy tất cả người dùng
    async getAllUsers(): Promise<ApiResponse<UserResponse>> {
        const endpoint = USER_ENDPOINTS.GET_ALL;
        return apiClient.get(endpoint);
    },

    // Lấy tất cả người dùng (quyền admin)
    async getAllUsersByAdmin(): Promise<ApiResponse<UserResponse>> {
        const endpoint = USER_ENDPOINTS.GET_ALL_BY_ADMIN;
        return apiClient.get(endpoint);
    },

    // Lấy danh sách người dùng có phân trang
    async getPaginationUsers(params: GetPaginationUsersDto): Promise<ApiResponse<UserListResponse>> {
        const endpoint = USER_ENDPOINTS.USERS;
        return apiClient.get(endpoint, params);
    },

    // Lấy thông tin người dùng theo ID
    async getUserById(id: string): Promise<ApiResponse<UserResponse>> {
        const endpoint = `${USER_ENDPOINTS.USERS}/${id}`;
        return apiClient.get(endpoint);
    },

    // Tạo người dùng mới
    async createUser(data: CreateUserDto): Promise<ApiResponse<UserResponse>> {
        const endpoint = USER_ENDPOINTS.USERS;
        return apiClient.post(endpoint, data);
    },

    // Cập nhật thông tin người dùng
    async updateUser(id: string, data: UpdateUserDto): Promise<ApiResponse<UserResponse>> {
        const endpoint = `${USER_ENDPOINTS.USERS}/${id}`;
        return apiClient.put(endpoint, data);
    },

    // Thay đổi mật khẩu
    async changePassword(data: ChangePasswordDto): Promise<ApiResponse<UserResponse>> {
        const endpoint = USER_ENDPOINTS.CHANGE_PASSWORD;
        return apiClient.put(endpoint, data);
    },

    // Cập nhật mật khẩu cho người dùng (quyền admin)
    async updatePassword(id: string, data: UpdatePasswordDto): Promise<ApiResponse<UserResponse>> {
        const endpoint = `${USER_ENDPOINTS.UPDATE_PASSWORD}/${id}`;
        return apiClient.put(endpoint, data);
    },

    // Cập nhật hồ sơ cá nhân
    async updateMe(data: { name?: string; email?: string; username?: string }): Promise<ApiResponse<any>> {
        return apiClient.put(USER_ENDPOINTS.UPDATE_ME, data);
    },

    // Xóa người dùng
    async deleteUser(id: string): Promise<ApiResponse<UserResponse>> {
        const endpoint = `${USER_ENDPOINTS.USERS}/${id}`;
        return apiClient.delete(endpoint);
    }
};
